export const dashboard = {
    alwaysShowDashboard: true,
    displayHeaderLink: false,
    displayedWidgets: {
        default: [],
    },
    redirectUrlBasicPage: '/page/home-infohunter'

};
